import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetStockTransfers = async (params: {
  page: number;
  limit: number;
  search?: string;
  from_store_id?: string | null;
  to_store_id?: string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/stock-transfers`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load stock transfers.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetStockTransferById = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/stock-transfers/id`, {
      params: { id },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to load stock transfer details.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateStockTransfer = async (payload: {
  from_store_id: string;
  to_store_id: string;
  note?: string;
  items: Array<{
    product_id: string;
    stock_id: string;
    quantity: number;
  }>;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/stock-transfers/create`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to create stock transfer.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
